// extracted by mini-css-extract-plugin
export default {"grid1":"ProductSearch_grid1__2GNcY","input":"ProductSearch_input__rQcCJ"};